<template>
  <div class="loginPage">
		<div class="loginComponent">
			<profile-form
			:preselectTopic="preselectTopic"
			></profile-form>
		</div>
  </div>
</template>

<script>

export default {
	name: 'ProfilePage',
	props: {
		preselectTopic: String
	},
	metaInfo: {
		title: 'User Profile'
	}
}
</script>
<style>
</style>
